<script>
  import { Card, WidgetPlaceholder, Spinner } from 'flowbite-svelte';
  import { Heading, OSChart } from '@button/ui';
  import { queryAggCreatorStats } from '../data/aggCreatorStats';
  import { sendReportCsvExportDebugEvent } from '../data/debug';
  import { searchParams } from '../store';
  import { _ } from 'svelte-i18n';
  import { createChartDataByKey } from '../utils';

  $: aggCreatorStats = queryAggCreatorStats({
    startDate: $searchParams.startDate,
    endDate: $searchParams.endDate,
    socialPlatform: $searchParams.socialPlatform,
    shortlinkId: $searchParams.shortlinkId,
  });
  $: currentData = $aggCreatorStats?.isSuccess
    ? $aggCreatorStats.data?.currentData || []
    : [];
  $: previousData = $aggCreatorStats?.isSuccess
    ? $aggCreatorStats.data?.previousData || []
    : [];
  $: chartData = createChartDataByKey({
    key: 'os',
    currentData,
    previousData,
  });

  $: isLoading = $aggCreatorStats.isLoading;
  $: isError = $aggCreatorStats.isError;
  $: hasData =
    $aggCreatorStats.isSuccess && chartData?.currentTotalJourneys > 0;
</script>

{#if isLoading || isError || hasData}
  <Card class="h-full w-full max-w-full">
    <Heading
      >{$_('reports.chart.clicksByOs.header', {
        default: 'Clicks by Operating System',
      })}</Heading
    >
    {#if isLoading}
      <div class="relative">
        <div class="absolute flex h-full w-full items-center justify-center">
          <Spinner />
        </div>
        <WidgetPlaceholder divClass="w-full p-6" />
      </div>
    {/if}
    {#if isError}
      <div class="flex h-full flex-col items-center justify-center">
        <p class="text-gray-500">
          {$_('reports.chart.clicksByOs.errors.default', {
            default: 'Something went wrong.',
          })}
        </p>
        <button
          class="mt-4 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          on:click={() => $aggCreatorStats.refetch()}
        >
          {$_('reports.chart.clicksByOs.cta.retry', { default: 'Retry' })}
        </button>
      </div>
    {/if}
    {#if hasData}
      <OSChart {chartData} {searchParams} {sendReportCsvExportDebugEvent} />
    {/if}
  </Card>
{/if}
